import { render } from "./ViewWallet.vue?vue&type=template&id=740b148f&scoped=true"
import script from "./ViewWallet.vue?vue&type=script&lang=js"
export * from "./ViewWallet.vue?vue&type=script&lang=js"

import "./ViewWallet.vue?vue&type=style&index=0&id=740b148f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740b148f"]])

export default __exports__